import { Component as e, useCallback as t, useEffect as n, useMemo as r, useRef as i, useState as a } from "react";
import { useHistory as o, useLocation as s } from "react-router-dom";
import c from "dayjs";
import l from "dayjs/plugin/timezone";
import u from "dayjs/plugin/utc";
import d from "dayjs/plugin/relativeTime";
import "dayjs/locale/es";
import f from "dayjs/plugin/customParseFormat";
import p from "dayjs/plugin/quarterOfYear";
import m from "lodash/debounce";
import { useFeatureFlagEnabled as ee, useFeatureFlagPayload as te, useFeatureFlagVariantKey as ne, usePostHog as h } from "posthog-js/react";
import re from "lodash/omit";
import g from "query-string";
import ie from "js-cookie";
import ae from "fuse.js";
import { AnalyticsBrowser as oe } from "@segment/analytics-next";
import se from "lodash/throttle";
//#region src/a11y/hooks/use-auto-focus-on-location-change.ts
var ce = (e) => {
	let t = s(), r = i(!1);
	n(() => {
		let t = e.current;
		r.current && t ? t.focus() : r.current = !0;
	}, [t, e]);
}, le = (e, t) => {
	let r = i(t);
	r.current = t;
	let a = !!t;
	n(() => {
		if (!a) return;
		let t = (t) => {
			let n = e.current, i = t.target;
			n && i instanceof Node && !n.contains(i) && r.current?.(t);
		};
		return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t, { passive: !0 }), () => {
			document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
		};
	}, [a, e]);
}, ue = (e) => {
	n(() => {
		if (!e) return;
		let t = (t) => {
			t.key === "Escape" && e(t);
		};
		return document.addEventListener("keydown", t), () => {
			document.removeEventListener("keydown", t);
		};
	}, [e]);
}, de = (e) => (t) => {
	(t.key === "Enter" || t.key === " ") && (t.preventDefault(), e());
}, fe = (e, t) => {
	let n = t - e + 1;
	return Array.from({ length: n }, (t, n) => n + e);
}, pe = (e) => {
	let t = (t) => e[t] ?? -1, n = Object.keys(e).sort((t, n) => e[t] - e[n]);
	return (e) => ({
		isAtLeast: (n) => t(e) >= t(n),
		isBefore: (n) => t(e) < t(n),
		isEqual: (t) => e === t,
		isGreater: (n) => t(e) > t(n),
		isOneOf: (...t) => t.includes(e),
		getNext: () => {
			let t = n.indexOf(e);
			return t >= 0 && t < n.length - 1 ? n[t + 1] : null;
		},
		getPrevious: () => {
			let t = n.indexOf(e);
			return t > 0 ? n[t - 1] : null;
		}
	});
}, _ = "YYYY-MM-DD", v = [
	"enero",
	"febrero",
	"marzo",
	"abril",
	"mayo",
	"junio",
	"julio",
	"agosto",
	"septiembre",
	"octubre",
	"noviembre",
	"diciembre"
], y = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
], b = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic"
], x = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
], S = "taxscouts_", me = {
	COMPANY_STREET_ADDRESS: "Calle Goya 15, planta 6",
	COMPANY_CITY: "Madrid",
	COMPANY_POSTCODE: "28001",
	COMPANY_COUNTRY: "España",
	COMPANY_CIF: "B01886308",
	SUPPORT_PHONE: "+34 932 20 75 12"
}, he = "en-uk", ge = "es-es", _e = (e, t) => c(e).add(t, "day").toDate(), ve = (e, t) => c(e).add(t, "hour").toDate(), ye = (e, t) => c(e).add(t, "month").toDate(), be = (e, t) => c(e).add(t, "year").toDate(), xe = (e, t) => c(t).diff(c(e), "month"), Se = /* @__PURE__ */ function(e) {
	return e.GB = "GB", e.ES = "ES", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.EUR = "EUR", e.GBP = "GBP", e.USD = "USD", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.EUR = "€", e.GBP = "£", e.USD = "$", e;
}({}), Ce = /* @__PURE__ */ function(e) {
	return e.EN = "en", e.ES = "es", e.DE = "de", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.GB = "en-GB", e.ES = "es-ES", e.CA = "ca-ES", e.GL = "gl-ES", e.EU = "eu-ES", e.IT = "it-IT", e.FR = "fr-FR", e.DE = "de-DE", e.PT = "pt-PT", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.GB = "Europe/London", e.ES = "Europe/Madrid", e;
}({}), we = (e, t, n = T.GB) => {
	if (c.extend(u), c.extend(l), !e) return null;
	let r = c.utc(e);
	return c.tz(r).locale(n).format(t);
}, Te = {
	[T.ES]: b,
	[T.GB]: x
}, Ee = (e, t = T.GB, n = !1) => {
	let r = new Date(e), i = Te[t][r.getMonth()], a = `${r.getDate()} ${i} ${r.getFullYear()}`;
	return n ? `${a} ${r.getUTCHours().toString().padStart(2, "0")}:${r.getUTCMinutes().toString().padStart(2, "0")}` : a;
}, De = (e, t, n = T.GB) => {
	if (c.extend(u), c.extend(l), !e) return null;
	let r = c.utc(e), i = n === T.ES ? E.ES : E.GB;
	return c.tz(r, i).locale(n).format(t);
};
//#endregion
//#region src/dates/formatDateQuery.ts
c.extend(u);
var Oe = (e) => e ? c.utc(e).format(_) : e ?? null, ke = (e) => e ? e.endsWith("Z") ? e : `${e}Z` : null;
//#endregion
//#region src/dates/formatDateDayAndMonth.ts
function Ae(e) {
	if (e >= 11 && e <= 13) return "th";
	switch (e % 10) {
		case 1: return "st";
		case 2: return "nd";
		case 3: return "rd";
		default: return "th";
	}
}
var je = (e, t = T.GB) => {
	let n = new Date(e), r = t === T.GB ? y[n.getMonth()] : v[n.getMonth()], i = n.getDate();
	return t === T.GB ? `${r} ${i}${Ae(i)}` : `${i} de ${r}`;
}, Me = (e, t = "D MMM・HH:mm") => (c.extend(u), c.extend(d), e ? c(e).isSame(c(), "day") ? c.utc(e).fromNow() : c.utc(e).format(t) : null), Ne = (e, t, n = T.GB) => {
	let r = n === T.ES ? E.ES : E.GB, i = c.utc(e), a = c.tz(i, r), o = a.clone().add(t, "minute");
	return `${a.format("HH:mm")} ${n === T.GB ? "to" : "a"} ${o.format("HH:mm")}`;
}, Pe = (e, t = T.GB, n) => {
	c.extend(u), c.extend(d), c.extend(l);
	let r = c.utc(e), i = t === T.ES ? E.ES : E.GB;
	return c.tz(r, i).locale(t).fromNow(n);
};
//#endregion
//#region src/dates/getDate.ts
c.extend(f);
var D = (e = c()) => c(e, _), Fe = (e) => c(e).format(_), Ie = (e) => {
	let t = c().startOf("day");
	return c(e).diff(t, "day", !1);
}, Le = (e, t) => {
	let n = c(e), r = c(t);
	return n.isAfter(r);
}, Re = () => c().year() + 1, ze = () => c().daysInMonth(), Be = ({ amount: e, unit: t, referenceDate: n }) => (n ? c(n) : c()).subtract(e, t).toDate(), Ve = (e, t) => {
	let n = new Date(e), r = new Date(t), i = Math.abs(r.getTime() - n.getTime());
	return Math.ceil(i / 864e5);
}, He = (e) => {
	c.extend(u);
	let t = c.utc(e), n = c.utc();
	return t.diff(n, "minute");
}, Ue = (e) => D(e || D()).month() + 1, We = (e, t = 1, n = "day") => c(e).subtract(t, n).format(_);
//#endregion
//#region src/dates/getStartOfQuarter.ts
c.extend(p);
var Ge = () => {
	let e = c().startOf("quarter");
	return {
		startOfCurrentQuarter: e,
		startOfLastQuarter: e.subtract(3, "month")
	};
};
//#endregion
//#region src/dates/getYear.ts
c.extend(u);
var Ke = (e) => c.utc(e).year(), qe = (e, t, n) => {
	let r = e ? new Date(e) : null, i = t ? new Date(t) : null, a = n ? new Date(n) : null, o = r?.getTime(), s = i?.getTime(), c = a?.getTime();
	return !o || !s || !c ? !1 : o >= s && o <= c;
}, Je = (e) => {
	let t = (e ?? /* @__PURE__ */ new Date()).getDay();
	return t === 6 || t === 0 || t === 5;
}, Ye = (e, t) => {
	let n = e ? new Date(e) : null, r = t ? new Date(t) : null;
	return n?.getTime() === r?.getTime();
}, Xe = (e = c(), t = c()) => c(e).isSame(c(t), "day"), Ze = (e) => !e || e.length <= 0 ? !1 : !Number.isNaN(new Date(e).getTime()), Qe = (e, t) => c(e).subtract(t, "day").toDate(), $e = (e, t) => c(e).subtract(t, "year").toDate(), et = m, tt = (e) => {
	let { baseUrl: t, vercelUrl: n, baseLocalePrefix: r = "", appBaseNamePath: i = "", pathname: a = "" } = e, o = n ? `https://${n}/` : "";
	return {
		baseUrl: t && t.length > 0 ? t : o,
		currentBaseLocalePrefix: r || (a.startsWith("/en-uk/") ? `/${he}` : a.startsWith("/es-es/") ? `/${ge}` : ""),
		appBaseNamePath: i
	};
}, O = (e, t) => {
	let n = e.startsWith("/") ? e : `/${e}`;
	return `${t.appBaseNamePath}${n}`;
}, nt = (e, t) => {
	let n = O(e, t);
	window.location.assign(n);
}, rt = class extends e {
	constructor(e) {
		super(e), this.state = { isChunkLoadError: !1 };
	}
	static getDerivedStateFromError(e) {
		let t = e?.name === "TypeError" && (/Failed to fetch dynamically imported module/.test(e?.message) || /error loading dynamically imported module/.test(e?.message) || /Importing a module script failed/.test(e?.message)), n = /Unable to preload CSS for/.test(e?.message);
		return {
			isChunkLoadError: t || n,
			error: e
		};
	}
	render() {
		let { children: e, renderError: t } = this.props, { isChunkLoadError: n, error: r } = this.state;
		if (n) return t();
		if (r) throw r;
		return e;
	}
}, it = (e, t) => {
	if (e) return t;
	let n = new URLSearchParams(window.location.search), r = {};
	return Object.keys(t).forEach((e) => {
		n.get(e) !== null && (r[e] = n.get(e) === "true");
	}), {
		...t,
		...r
	};
}, at = (e) => ne(e), ot = () => {
	let e = h(), [t, r] = a(!0);
	return n(() => {
		t && (e.onFeatureFlags(() => {
			r(!1);
		}), setTimeout(() => {
			r(!1);
		}, 3e3));
	}, [t, e]), { isLoading: t };
}, st = (e, t) => !!e && t.map((e) => e.toLowerCase()).includes(e.toLowerCase().slice(e.lastIndexOf(".") + 1, e.length)), ct = ({ blob: e, fileName: t }) => {
	let n = URL.createObjectURL(e), r = document.createElement("a");
	r.href = n, r.download = t, r.click(), URL.revokeObjectURL(n);
}, lt = ({ multiple: e = !1, onChange: t, accept: n }) => {
	let r = document.createElement("input");
	r.hidden = !0, r.type = "file", r.multiple = e, n && (r.accept = n), r.onchange = (e) => {
		let n = e.target;
		n && (t(Array.from(n.files ?? [])), n.value = "");
	}, r.click();
}, ut = async (e) => {
	let t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-1", t);
	return Array.from(new Uint8Array(n)).map((e) => e.toString(16).padStart(2, "0")).join("");
}, dt = async (e) => {
	let t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
	return Array.from(new Uint8Array(n)).map((e) => e.toString(16).padStart(2, "0")).join("");
}, ft = ({ getItemKey: e, initialSelectedItems: t = [], items: n, onSelectionChange: r }) => {
	let [i, o] = a(t), s = (e) => {
		o(e), r?.(e);
	};
	return {
		selectedItems: i,
		deselectAll: () => {
			s([]);
		},
		selectAll: () => {
			n && s([...n]);
		},
		toggleItemSelection: (t) => {
			let n = e(t), r = i.some((t) => e(t) === n) ? i.filter((t) => e(t) !== n) : [...i, t];
			s(r);
		}
	};
}, pt = () => {
	let e = i(!0);
	return [e, t(() => {
		e.current = !1;
	}, [])];
}, mt = ({ lang: e }) => ({
	didomiConfig: r(() => ({
		languages: {
			enabled: [e],
			default: e
		},
		user: { bots: { consentRequired: !1 } }
	}), [e]),
	handleReady: (e) => {
		e.shouldConsentBeCollected() && e.notice.show();
	}
}), k = (e) => e ? e.scrollHeight > e.clientHeight ? e : k(e.parentElement) : null, ht = 25, gt = (e) => document.scrollingElement ? window.outerWidth - ht + document.scrollingElement.scrollLeft <= e : window.outerWidth - ht <= e, _t = (e) => e.scrollTo(0, 0), vt = () => {
	window.scrollTo(0, 9999999);
}, yt = (e) => {
	e ? window.scrollTo({
		top: 0,
		left: 0,
		behavior: e
	}) : window.scrollTo(0, 0);
}, bt = (e, t = 0, n = "smooth") => {
	if (!e) return;
	let r = k(e);
	if (!r) return;
	let i = e.offsetParent, a = e.offsetTop + (i?.offsetTop || 0) + t;
	r.scrollTo({
		top: a,
		behavior: n
	});
}, xt = () => {
	document.body.style.overflow = "hidden";
}, A = () => {
	document.body.style.overflow = "unset";
}, St = () => {
	n(() => (xt(), () => {
		A();
	}), []);
}, j = !1, M = (e, t, n) => {
	try {
		localStorage.setItem(n ? n + e : e, t);
	} catch (e) {
		F(e);
	}
}, N = (e, t) => {
	try {
		localStorage.removeItem(t ? t + e : e);
	} catch (e) {
		F(e);
	}
}, P = (e, t) => {
	try {
		return localStorage.getItem(t ? t + e : e);
	} catch (e) {
		return F(e), null;
	}
}, F = (e) => {
	if (typeof window.localStorage != "object") {
		if (j) return;
		j = !0, alert("Your web browser does not support storing settings locally. In Safari, the most common cause of this is using \"Private Browsing Mode\". In other cases please try using a different browser.");
	} else throw e;
}, I = !1, L = (e, t) => {
	try {
		sessionStorage.setItem(e, t);
	} catch (e) {
		B(e);
	}
}, R = (e) => {
	try {
		sessionStorage.removeItem(e);
	} catch (e) {
		B(e);
	}
}, z = (e) => {
	try {
		return sessionStorage.getItem(e);
	} catch (e) {
		return B(e), !1;
	}
}, B = (e) => {
	if (typeof window.sessionStorage != "object") {
		if (I) return;
		I = !0, alert("Your web browser does not support storing settings locally. In Safari, the most common cause of this is using \"Private Browsing Mode\". In other cases please try using a different browser.");
	} else throw e;
}, Ct = (e, t) => {
	if (!e) throw Error(`"key" must be a non-empty string, but "${e}" was passed.`);
	try {
		let n = P(e);
		return n ? JSON.parse(n) : t;
	} catch (n) {
		return console.warn(`Error reading storage key “${e}”:`, n), t;
	}
}, wt = (e, r) => {
	let i = S + e, [o, s] = a(() => Ct(i, r)), c = t(() => {
		try {
			N(i), s(void 0);
		} catch (e) {
			console.warn(`Error removing storage key “${i}”:`, e);
		}
	}, [i]);
	return n(() => {
		o !== void 0 && M(i, JSON.stringify(o));
	}, [i, o]), [
		o,
		s,
		c
	];
}, Tt = (e) => {
	n(e, []);
}, V = () => {
	let e = s(), n = r(() => g.parse(e.search), [e.search]);
	return {
		queryParams: n,
		overwriteQueryParams: t((t) => ({
			...e,
			search: g.stringify(t)
		}), [e]),
		updateQueryParams: t((t, r) => ({
			...e,
			...r && { pathname: r },
			search: g.stringify({
				...n,
				...t
			})
		}), [n, e]),
		removeQueryParams: t((t) => {
			let r = re(n, t);
			return {
				...e,
				search: g.stringify(r)
			};
		}, [n, e])
	};
}, H = (e) => btoa(encodeURIComponent(JSON.stringify(e))), Et = (e) => JSON.parse(decodeURIComponent(atob(e))), Dt = (e) => {
	let { defaultFilter: i } = e, a = o(), { queryParams: s, updateQueryParams: c } = V(), l = r(() => {
		let { filter: e } = s;
		if (!e) return i;
		try {
			return Et(e);
		} catch {
			return i;
		}
	}, [s, i]), u = t(({ updatedFilter: e }) => {
		let t = {
			...l,
			...e
		};
		a.replace(c({ filter: H(t) }));
	}, [
		l,
		a,
		c
	]), d = t(() => {
		a.replace(c({ filter: H(i) }));
	}, [
		i,
		a,
		c
	]), f = t((e) => {
		let t = { ...l };
		e.forEach((e) => delete t[e]), a.replace(c({ filter: H(t) }));
	}, [
		l,
		a,
		c
	]), p = t(({ updatedFilter: e }) => {
		a.replace(c({ filter: H({ ...e }) }));
	}, [a, c]), m = !s.filter;
	return n(() => {
		m && u({ updatedFilter: i });
	}, [
		u,
		i,
		m
	]), {
		activeFilters: l,
		applyFilter: u,
		clearFilters: d,
		removeFilter: f,
		replaceFilter: p
	};
}, Ot = (e, t) => {
	let i = r(() => new ResizeObserver((e) => t(e[0].target)), [t]);
	n(() => {
		if (!e.current) return;
		let t = e.current;
		return i.observe(t), () => i.unobserve(t);
	}, [i, e]);
}, kt = (e, t) => {
	try {
		return new URL(e).origin === new URL(t).origin;
	} catch {
		return !1;
	}
}, At = (e, r) => {
	let i = t((t) => {
		kt(t.origin, r) ? e(t) : console.warn("Rejected message from", t.origin, "expected", r);
	}, [e, r]);
	n(() => (window.addEventListener("message", i), () => window.removeEventListener("message", i)), [i]);
}, U = (e, t = { isSmooth: !1 }) => {
	let { isSmooth: n } = t;
	e?.scrollIntoView({
		behavior: n ? "smooth" : "auto",
		block: "start"
	});
}, jt = (e) => e.slice(1), Mt = (e) => {
	let { skipAutoScroll: r = !1 } = e || {}, i = s(), [o, c] = a(null), l = t((e) => U(o, e), [o]);
	return n(() => {
		let e = i.hash;
		if (e) {
			let t = document.getElementById(jt(e));
			c(t ?? void 0), r || U(t, { isSmooth: !0 });
		} else c(void 0);
	}, [i.hash, r]), {
		hashElement: o,
		scrollToHashElement: l
	};
}, Nt = (e, t) => {
	if (!e) throw Error(`"key" must be a non-empty string, but "${e}" was passed.`);
	try {
		let n = z(e);
		return n ? JSON.parse(n) : t;
	} catch (n) {
		return console.warn(`Error reading storage key “${e}”:`, n), t;
	}
}, Pt = (e, t) => {
	let r = S + e, [i, o] = a(() => Nt(r, t));
	return n(() => {
		L(r, JSON.stringify(i));
	}, [r, i]), [
		i,
		o,
		() => R(r)
	];
}, Ft = (e, t) => {
	n(() => {
		if (e && t) return document.title = `${e} - ${t}`, () => {
			document.title = t;
		};
		e && (document.title = e);
	}, [e, t]);
}, It = (e = !1) => {
	let [n, r] = a(e);
	return [
		n,
		t(() => r(!0), []),
		t(() => r(!1), []),
		t(() => {
			r((e) => !e);
		}, []),
		r
	];
}, Lt = (e) => typeof e == "string" ? e.replace(/[^A-Za-z0-9]/g, "") : e, Rt = (e) => typeof e == "string" ? e.toUpperCase() : e, zt = (e) => (t) => ("error" in t || e(t.data), t), Bt = (e) => (t) => ("error" in t && e(t.error), t), Vt = (e) => "error" in e, Ht = (e) => "error" in e ? [null, e.error] : [e.data, null], Ut = (e) => e.error ? { error: e.error } : { data: e.data }, Wt = () => ie.get("expo-push-token"), Gt = (e, t) => {
	let n = e.split(".").map(Number), r = t.split(".").map(Number);
	for (let e = 0; e < Math.max(n.length, r.length); e++) {
		let t = n[e] || 0, i = r[e] || 0;
		if (t < i) return -1;
		if (t > i) return 1;
	}
	return 0;
}, Kt = () => {
	let e = W(), t = navigator.userAgent.split(" "), n = t.some((e) => e.includes("ExpoGo/")), r = t.find((e) => e.includes("TaxScouts/") || e.includes("Taxfix/"))?.split("/"), i = r?.[1], a = r?.[2];
	return {
		isMobileAppMode: e,
		getShouldUpdateApp: (t) => !e || n || !i ? !1 : Gt(i, t) < 0,
		isIos: a === "ios",
		isAndroid: a === "android"
	};
}, W = () => {
	if (!navigator?.userAgent) return !1;
	let e = navigator.userAgent.includes("ExpoGo/"), t = navigator.userAgent.includes("TaxScouts/") || navigator.userAgent.includes("Taxfix/");
	return e || t;
}, qt = (e) => e.default ?? e, Jt = {
	[C.EUR]: w.EUR,
	[C.GBP]: w.GBP,
	[C.USD]: w.USD
}, Yt = (e) => Jt[C[e]] ?? e, G = [T.ES], Xt = (e, { locale: t }) => G.includes(t) ? e.replace(",00", "") : e.replace(".00", ""), Zt = (e) => G.includes(e) ? "," : ".", Qt = (e, { currency: t, locale: n, removeSpaces: r = !0, removeMeaninglessDecimals: i = !0 }) => {
	let a;
	try {
		a = new Intl.NumberFormat(n, {
			style: "currency",
			currency: t,
			currencyDisplay: "narrowSymbol"
		});
	} catch {
		a = { format: (e) => `${(e ?? 0).toFixed(2).replace(".", Zt(n))}${Yt(t)}` };
	}
	let o = a.format(e);
	return r && (o = o.replace(/\s/g, "")), i && (o = Xt(o, { locale: n })), o;
}, $t = (e, t) => new Intl.NumberFormat(t.locale, {
	style: "percent",
	maximumFractionDigits: 2
}).format((e || 0) / 100).replace(/\s/, ""), en = (e, t = 2) => String(e).padStart(t, "0"), tn = (e, t, n) => {
	let r = e;
	return t && Object.entries(t).forEach(([e, t]) => {
		let n = RegExp(`:${e}`, "g");
		r = r.replace(n, `${t}`);
	}), n?.queryParameters && (r += `?${g.stringify(n.queryParameters)}`), r;
}, nn = (e) => e.pathname + e.search + e.hash, rn = (e) => e.endsWith("/") ? e : `${e}/`, K = (e, t) => typeof window < "u" && window.ReactNativeWebView && W() ? e(window.ReactNativeWebView) : t(), q = (e, t) => {
	typeof window < "u" && window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({
		type: e,
		data: t
	}));
}, J = {
	fileDownload: (e) => {
		q("fileDownload", e);
	},
	profile: (e) => {
		q("profile", e);
	},
	shareText: (e) => {
		q("shareText", e);
	},
	trackingEvent: (e) => {
		q("trackingEvent", e);
	}
}, an = () => !!navigator.share || W(), on = (e) => {
	K(() => {
		J.shareText(e);
	}, () => {
		navigator.share && navigator.share(e).catch((e) => {
			if (e.name !== "AbortError") throw e;
		});
	});
}, Y = (e, t, n = { treshold: .1 }) => {
	let r = new ae([e], {
		includeScore: !0,
		threshold: 1,
		ignoreLocation: !0
	}).search(t);
	if (!r[0] || !r[0].score) return {
		score: 0,
		matches: !1
	};
	let { score: i } = r[0];
	return {
		score: i,
		matches: i <= n.treshold
	};
}, sn = ({ fileName: e, customerFirstName: t, customerLastName: n }) => {
	let r = `${t}${n}`.replaceAll(" ", "").toLowerCase(), i = `${n}${t}`.replaceAll(" ", "").toLowerCase(), a = e.replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "").toLowerCase();
	return a.includes(r) || a.includes(i) || Y(a, r).matches || Y(a, i).matches;
}, cn = (e) => e && e.charAt(0).toLowerCase() + e.slice(1), ln = (e, t) => {
	let n = e.split("").filter((e) => e !== " ").join("");
	return n.charAt(0) === "+" ? n : `${t?.countryPrefix ?? ""}${n}`;
}, un = ({ door: e = "", floor: t = "", number: n = "", stairs: r = "", street: i = "", streetType: a = "" } = {}) => {
	let o = [`${a}/${i}`];
	return n && o.push(`nº ${n}`), r && o.push(`escalera ${r}`), t && o.push(`piso ${t}`), e && o.push(`puerta ${e}`), o.join(", ");
}, dn = (e) => e === "null" ? null : e === "true" ? !0 : e === "false" ? !1 : Number(e) > 0 || Number(e) === 0 ? Number(e) : e, fn = (e = "") => e.split(/(?=[A-Z])/).join(" "), pn = (e) => e.toLowerCase().split(" ").map((e) => e.charAt(0).toUpperCase() + e.substring(1)).join(" "), mn = (e, t = 2) => e.split(" ").filter((e) => e.length > 0).slice(0, t).map((e) => e[0]).join("").toUpperCase(), hn = (e) => e === !0 ? "true" : e === !1 ? "false" : String(e), gn = (e, t = 18, n = "...") => {
	if (e.length <= t) return e;
	let r = Math.max(0, t - n.length), i = Math.ceil(r / 2), a = Math.floor(r / 2);
	return e.slice(0, i) + n + e.slice(e.length - a);
}, _n = (e) => !e || !("offsetWidth" in e) || !("scrollWidth" in e) ? !1 : e.offsetWidth < e.scrollWidth, vn = (e, t = 1) => {
	let n;
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(e)) return n = e.substring(1).split(""), n.length === 3 && (n = [
		n[0],
		n[0],
		n[1],
		n[1],
		n[2],
		n[2]
	]), n = `0x${n.join("")}`, `rgba(${[
		n >> 16 & 255,
		n >> 8 & 255,
		n & 255
	].join(",")},${t})`;
	throw Error("Bad Hex");
}, yn = (...e) => e.filter(Boolean).join(" "), X = null, bn = (e) => ({
	name: "app-version",
	type: "enrichment",
	version: "1.0.0",
	isLoaded: () => !0,
	load: () => Promise.resolve(),
	track: (t) => (t.updateEvent("context.app.version", e), t),
	identify: (t) => (t.updateEvent("context.app.version", e), t),
	page: (t) => (t.updateEvent("context.app.version", e), t)
}), xn = ({ writeKey: e, appVersion: t }) => {
	if (X) return X;
	let n = t ? [bn(t)] : [];
	return X = oe.load({
		writeKey: e,
		plugins: n
	}), X;
}, Z = () => X, Q = (e) => {
	if (e) return e.replace(/^\/(en-uk|es-es)/, "") || "/";
}, Sn = () => {
	let e = h(), n = t((t, n, r) => {
		r === void 0 ? e.identify(String(t), n) : e.identify(String(t), n, r);
	}, [e]), r = t((t) => {
		e.capture("$pageview", {
			...t,
			$pathname: Q(window.location.pathname)
		});
	}, [e]), i = t((t, n) => {
		e.capture(String(t), {
			...n,
			$pathname: Q(window.location.pathname)
		});
	}, [e]), a = t((t) => {
		e.setPersonPropertiesForFlags(t);
	}, [e]);
	return {
		identifyUser: n,
		capturePageView: r,
		captureEvent: i,
		reset: t(() => {
			e.reset();
		}, [e]),
		setPersonPropertiesForFlags: a
	};
}, Cn = () => ({
	identifyUser: t((e, t) => {
		let n = Z();
		n && n.identify(String(e), t);
	}, []),
	capturePageView: t((e) => {
		let t = Z();
		t && t.page(void 0, void 0, {
			...e,
			$pathname: Q(window.location.pathname)
		});
	}, []),
	captureEvent: t((e, t) => {
		let n = Z();
		n && n.track(String(e), {
			...t,
			$pathname: Q(window.location.pathname)
		});
	}, []),
	reset: t(() => {
		let e = Z();
		e && e.reset();
	}, [])
}), $ = () => ({ is_mobile_app_mode: W() }), wn = () => {
	let e = Sn(), n = t((t, n) => {
		let r = {
			...n ?? {},
			...$()
		};
		e.captureEvent(t, r);
	}, [e]), r = t((t) => {
		e.capturePageView({
			...t,
			...$()
		});
	}, [e]);
	return {
		...e,
		captureEvent: n,
		capturePageView: r
	};
}, Tn = () => ({
	identifyUser: t((e) => {
		typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
			userId: e,
			user_id: e
		}));
	}, []),
	captureEvent: t((e, t) => {
		typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
			event: e,
			...t
		}));
	}, [])
}), En = {
	BookkeepingInvoiceCreate: "bookkeeping_invoice_create",
	BookkeepingInvoiceEdit: "bookkeeping_invoice_edit",
	BookkeepingInvoiceIssued: "bookkeeping_invoice_issued",
	BookkeepingInvoiceDownload: "bookkeeping_invoice_download",
	BookkeepingInvoiceSend: "bookkeeping_invoice_send",
	BookkeepingInvoiceDownloadQuote: "bookkeeping_invoice_download_quote",
	BookkeepingIncomeCreate: "bookkeeping_income_create",
	BookkeepingIncomeBulkUpload: "bookkeeping_income_bulk_upload",
	BookkeepingExpenseCreate: "bookkeeping_expense_create",
	BookkeepingExpenseBulkUpload: "bookkeeping_expense_bulk_upload",
	BookkeepingBulkImportSpreadsheetUpload: "bookkeeping_bulk_import_spreadsheet_upload",
	BookkeepingBulkImportApprove: "bookkeeping_bulk_import_approve"
}, Dn = se, On = (e) => Object.keys(e), kn = (e) => e != null;
//#endregion
export { me as ADDRESS_TAXSCOUTS_SPAIN, rt as ChunkLoadErrorBoundary, Se as CountryCode, C as CurrencyCode, w as CurrencySymbol, _ as DATE_FORMAT, y as EN_MONTH_NAMES_LONG, x as EN_MONTH_NAMES_SHORT, v as ES_MONTH_NAMES_LONG, b as ES_MONTH_NAMES_SHORT, Ce as Language, T as Locale, J as ReactNativeMessages, S as STORAGE_KEY_PREFIX, E as TimeZone, En as TrackingEvent, ge as URL_BASE_LOCALE_PREFIX_SPAIN, he as URL_BASE_LOCALE_PREFIX_UK, _e as addDays, ve as addHours, ye as addMonths, be as addYears, sn as compareFilenameWithCustomerName, Y as compareStrings, O as createAppUrlFromConfig, tt as createDomainConfig, pe as createStatusChecker, et as debounce, cn as decapitalizeString, xt as disableBodyScroll, A as enableBodyScroll, Qt as formatCurrency, je as formatDateDayAndMonth, Oe as formatDateQuery, ke as formatDateStringAsUTC, we as formatDateUTC, Ee as formatDateWithShortMonthNames, De as formatDateWithTimezone, ln as formatE164PhoneNumber, rn as formatPathWithEndingSlash, $t as formatPercentage, un as formatStreetAddress, Pe as formatTimeFromNow, Ne as formatTimePeriod, Me as formatTimeTodayAndDateIfLater, dn as fromString, tn as generateApiPath, an as getCanShare, gt as getClickedOnScrollbar, D as getDate, Be as getDateFromTimeAgo, ze as getDaysInCurrentMonth, Ie as getDaysToDate, Ve as getDifferenceInDays, Wt as getExpoPushToken, nn as getFullPath, $ as getGlobalEventProperties, Le as getIsAfterDate, st as getIsFileType, W as getIsMobileAppMode, _n as getIsOverflowActive, He as getMinutesToDate, Kt as getMobileAppDetails, Ue as getMonth, xe as getMonthDiff, Re as getNextYear, On as getObjectKeysTyped, We as getPreviousDate, fe as getRange, k as getScrollableAncestor, Z as getSegmentAnalytics, Ge as getStartOfQuarter, Fe as getStringDate, Ke as getYear, de as handleKeyDownEvent, vn as hexToRgbA, xn as initSegment, qt as interopDefault, qe as isBetweenDates, Je as isDateFridayToSunday, kn as isDefined, Vt as isResponseError, Ye as isSameDate, Xe as isSameDay, Ze as isValidStringDate, yn as joinClasses, P as localStorageGet, N as localStorageRemove, M as localStorageSet, Ut as mapQueryToMatchableResponse, Bt as matchErrorResponse, K as matchIsMobileMode, zt as matchSuccessResponse, nt as navigateToAppUrlFromConfig, Q as normalizePath, lt as openFileDialog, it as overrideFeatureFlagsWithQueryParams, en as padWithZeroes, ct as saveBlobAsFile, _t as scrollElementToTop, vt as scrollPageToBottom, yt as scrollPageToTop, bt as scrollToTarget, z as sessionStorageGet, R as sessionStorageRemove, L as sessionStorageSet, on as share, fn as splitStringAtUppercase, ut as stringToSHA1Hash, dt as stringToSHA256Hash, pn as stringToTitleCase, Qe as subtractDays, $e as subtractYears, Dn as throttle, mn as toAcronym, Lt as toAlphaNumerical, hn as toString, Rt as toUpperCase, gn as truncateTextMiddle, Ht as unwrapResponse, ce as useAutoFocusOnLocationChange, wn as useBookkeepingEventTracking, ft as useCheckboxListSelection, pt as useComponentDidMount, Tn as useDataLayerTracking, mt as useDidomiConsent, St as useDisablePageScroll, at as useExperimentFeatureFlagVariant, ee as useFeatureFlagEnabled, te as useFeatureFlagPayload, ot as useInitFeatureFlags, wt as useLocalStorage, le as useOnClickOutside, ue as useOnEscapeKeydown, Tt as useOnMount, Sn as usePostHogTracking, Dt as useQueryParamFilter, V as useQueryParams, Ot as useResizeObserver, At as useSameOriginPostMessageListener, Mt as useScrollToHashElement, Cn as useSegmentTracking, Pt as useSessionStorage, Ft as useSetTitle, It as useToggle };

//# sourceMappingURL=index.js.map